import React from 'react'

import { JaneProductApiResponse } from '../../redux/types/products'

interface Props {
  product: JaneProductApiResponse | undefined
}

export const ProductClipboard = (props: Props) => {
  const { product } = props
  return (
    <table id="product-clipboard-table" hidden>
      <tbody>
        <tr>
          <td style={{ fontSize: 12 }}>{product?.name}</td>
          <td style={{ fontSize: 12 }}>{product?.brand}</td>
          <td style={{ fontSize: 12 }}>{product?.kind}</td>
          <td style={{ fontSize: 12 }}>{product?.kind_subtype}</td>
          <td style={{ fontSize: 12 }}>{product?.root_subtype}</td>
          <td style={{ fontSize: 12 }}>{product?.category}</td>
          <td style={{ fontSize: 12 }}>{product?.amount}</td>
          <td style={{ fontSize: 12 }}>{product?.dosage}</td>
          <td style={{ fontSize: 12 }}>{product?.cbd_dosage_milligrams || ''}</td>
          <td style={{ fontSize: 12 }}>{product?.thc_dosage_milligrams || ''}</td>
          <td style={{ fontSize: 12 }}>{product?.quantity_value || ''}</td>
          <td style={{ fontSize: 12 }}>{product?.quantity_units}</td>
          <td style={{ fontSize: 12 }}>{product?.description}</td>
        </tr>
      </tbody>
    </table>
  )
}
